import React, {setState, useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import PropTypes from 'prop-types';
import { makeStyles, useTheme, alpha } from '@material-ui/core/styles';
import styles from "./Whites.module.css";
import Container from '@material-ui/core/Container'
import { useLocation } from 'react-router-dom';
import {DataGrid, GridToolbar, GridCellEditStopReasons} from "@mui/x-data-grid";
import { deleteWhite, getWhitesByUser } from '../../actions/whiteActions';
import NoData from '../svgIcons/NoData';
import Spinner from '../Spinner/Spinner'
import { useSnackbar } from 'react-simple-snackbar'
import { Button } from '@material-ui/core';
import useAuthUser from '../../hooks/useAuthUser'
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),

  },
}));

const useStyles2 = makeStyles(theme => ({
  table: {
    minWidth: 500,
    
  },

  tablecell: {
    fontSize: '16px'
}
}));

const tableStyle = { width: 160, fontSize: 14, cursor: 'pointer', borderBottom: 'none',  padding: '8px', textAlign: 'center' }
const headerStyle = { borderBottom: 'none', textAlign: 'center'}


const Whites = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const {whites} = useSelector(state => state.whites);
  const authData = useAuthUser()
  const [rows, setRows] = useState(whites);
  const isLoading = useSelector(state => state.whites.isLoading)
        // eslint-disable-next-line 
  const [openSnackbar, closeSnackbar] = useSnackbar()
  const [selectedDate, setSelectedDate] = useState(null);
  const isWhites = location.pathname === "/whites";
  const statuses = ['Unpaid', 'Paid', 'Partial']
  const clientArray = [...new Set(whites.map(invoice => {
    if (invoice.client.store) {
      return invoice.client.store
    }
  }))]

    const formatDollarsToCents = function (value) {
    value = `${value}`.replace(/[^\d.-]/g, '');
    if (value && value.includes('.')) {
        value = value.substring(0, value.indexOf('.') + 3);
    }
  
    return value ? Math.round(parseFloat(value) * 100) : 0;
  };
  
  const formatCentsToDollars = function (value) {
    value = `${value}`.replace(/[^\d.-]/g, '');
    value = parseFloat(value);
    return value ? value / 100 : 0;
  };

  // Create our number formatter.
const dollar_formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
});

  const displayAsDollars = function(params) {
    return dollar_formatter.format(formatCentsToDollars(params))
  }


  // const rows = []


    // useEffect(() => {
    //     dispatch(getWhites());
    // }, [dispatch]);

    useEffect(() => {
        const userId = authData?.result?._id || authData?.result?.googleId
        if (userId) {
          dispatch(getWhitesByUser({search: userId}));
        }
      // eslint-disable-next-line
    },[location, authData])

    useEffect(() => {
      setRows(whites)
    }, [whites])

   const toCommas = (value) => {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }

  const classes = useStyles2();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(rows.length);

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDateChange = (value) => {
    if (value !== null) {
      let val = moment(value).format('MM/DD/yyyy');
      setSelectedDate(val);
      const filteredRows = whites.filter((row) => {
        if (moment(row.receivedByDate).format('MM/DD/yyyy').includes(val)) {
          return true;
        }
        return false;
      });
      setRows(filteredRows);
    } else {
      setRows(whites);
    }
  }

  const customDateComparator = (v1, v2) => new Date(v1) - new Date(v2)
  
    const columns = [
      {
        field: 'client',
        headerName: 'Client',
        type: 'singleSelect',
        valueOptions: clientArray,
        editable: false,
        minWidth: 125,
        flex: 1,
        valueGetter: (params) => {
          if (!params.value) {
            return params.value;
          }
          const valueFormatted = params.value.store;
          return valueFormatted;
        }, 
      },
      { 
        field: 'total', 
        headerName: 'Amount', 
        flex: 1,
        minWidth: 100, 
        editable: false,
        valueGetter: (params) => {
          if (!params.value) {
            return params.value;
          }
          const valueFormatted = '$' + toCommas(params.value);
          return valueFormatted;
        },  
      },
      { 
        flex: 1,
        minWidth: 150,
        field: 'receivedByDate', 
        headerName: 'Received Date', 
        width: 150, 
        editable: false,
        type: 'date',
        valueGetter: (params) => {
          if (!params.value) {
            return params.value;
          }
          // const valueFormatted = moment(params.value).format('MM/DD/yyyy');
          // return valueFormatted;
          const valueFormatted = new Date(params.value);
          return valueFormatted;
        },
      },
      { 
        flex: 1,
        minWidth: 150,
        field: 'dueDate', 
        headerName: 'Due Date', 
        width: 150, 
        editable: false,
        type: 'date',
        valueGetter: (params) => {
          if (!params.value) {
            return params.value;
          }
          // const valueFormatted = moment(params.value).format('MM/DD/yyyy');
          // return valueFormatted;
          const valueFormatted = new Date(params.value);
          return valueFormatted;
        },
      },
      { field: 'status', 
        headerName: 'Status', 
        width: 125, 
        type: 'singleSelect',
        valueOptions: statuses,
        renderCell: (params) => {
        return (
          <button style={checkStatus(params.value)}>{params.value}</button>
        );
      } },
      { field: 'actions', headerName: 'Actions', headerAlign: 'center', align: 'center', flex:1, minWidth: 200, renderCell: (params) => {
        return (
          <div style={{display: 'flex'}}>
            <Button
              style={{color: 'white', backgroundColor: 'rgb(25, 118, 210)', marginRight: 10}}
              onClick={() => editWhite(params.row._id)}
              variant="contained"
            >
              Edit
            </Button>
            <Button
              style={{color: 'white', backgroundColor: 'red'}}
              onClick={(e) => {
                e.stopPropagation();
                dispatch(deleteWhite(params.row._id, openSnackbar))
              }}
              variant="contained"
            >
              Delete
            </Button>
              
    
          </div>
          
        );
      } }
    ];


  const editWhite = (id) => {
    history.push(`/edit/white/${id}`)
  }

  const openWhite = (id) => {

    history.push(`/white/${id}`)
  }

  if(!authData) {
    history.push('/login')
  }



  function checkStatus(status) {
    return status === "Partial" ? {border: 'solid 0px #1976d2', backgroundColor: '#baddff', padding: '8px 18px', borderRadius: '20px' }
        : status === "Paid" ? {border: 'solid 0px green', backgroundColor: '#a5ffcd', padding: '8px 18px', borderRadius: '20px' }
        : status === "Unpaid" ? {border: 'solid 0px red', backgroundColor: '#ffaa91', padding: '8px 18px', borderRadius: '20px' }
        : "red";
          
}

  if(isLoading) {
    return  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', paddingTop: '20px'}}>
        <Spinner />
    </div>
  }

  if(rows.length === 0 && whites.length === 0) {
    return  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', paddingTop: '20px', margin: '80px'}}>
      <NoData />
    <p style={{padding: '40px', color: 'gray', textAlign: 'center'}}>No white yet. Click the plus icon to create white</p>
  
    </div>
  }

  return (
      <div className={styles.pageLayout}>
        <Container style={{maxWidth: 1600}}>
          <div className={styles.buttons}>
          <h1 style={{paddingTop: 10}}>Whites</h1>
          </div>
          <div className={styles.gridLayout}>
                <DataGrid
                    sx={{
                    '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '6px' },
                    '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '8px' },
                    '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '12px' },
                  }}
                  autoHeight
                  rows={whites}
                  getRowId={(row) => row._id}
                  getRowHeight={() => 'auto'}
                  columns={columns}
                  pageSize={20}
                  components={{
                    Toolbar: GridToolbar,
                  }}
                  onRowClick={(row) => openWhite(row.id)}
                  onStateChange={(e) => {
                    if (e.filter.filterModel.items.length > 0) {
                      if (e.filter.filterModel.items[0].field === 'receivedByDate' && e.filter.filterModel.items[0].value !== "") {
                        let temp = moment(e.filter.filterModel.items[0].value).format('MM/DD/yyyy')
                        setSelectedDate(temp)
                        // console.log(e.filter.filterModel.items[0].value)
                      }
                    }
                  }}
                  sortingOrder={['desc','asc']}
                initialState={{
                  sorting: {
                    sortModel: [
                      {
                        field: 'receivedByDate',
                        sort: 'desc'
                      }
                    ]
                  }
                }}
                />
            </div>
        </Container>
      </div>
    
    );
}

export default Whites
